import Vue from "vue";
import axios from "axios";
import users from "@/users";
import { validationMixin } from "vuelidate";
import {
  required,
  requiredIf,
  email,
  minLength,
  maxLength,
} from "vuelidate/lib/validators";
import moment from "moment";
import { DxFileUploader } from "devextreme-vue";
import * as utils from "../../utils";
import otpDelayFunc from "@/otpDelayFunc";

const regExpression = function (value) {
  return utils.validatePhoneNumber(value, this.regExpr);
};

export default {
  name: "NewCustomer",
  mixins: [users, validationMixin, otpDelayFunc],
  components: {
    AttachmentsComp: require("@/components/attachments.vue").default,
    CustomFieldsComp: require("@/components/customFieldsApp.vue").default,
    DxFileUploader,
  },
  data: function () {
    return {
      registrationMsg: null,
      regExpr: "",
      loader: false,
      phoneOtpCode: null,
      emailOtpCode: null,
      expiryTmeout: null,
      timerCount: 0,
      timeLimit: null,
      timerStarted: false,
      timerCountDisplay: "",
      regExpired: false,
      sessionId: null,
      phonePrefix: null,

      registrationMessage: null,
      isRegistering: false,
      formData: new FormData(),
      showCustomFields: false,
      tabs: {
        general: { sync: false, error: "" },
        addresses: { sync: false, error: "" },
        consent: { sync: false, error: "" },
        attachments: { sync: false, error: "" },
        customFields: { sync: false, error: "" },
      },
      birthDate: null,
      lookups: {},
      dataObj: {
        PortalApplicationId: -1,
        AccountType: 0,
        ConsumerType: "",
        Initial: "",
        Surname: "",
        Email: "",
        Title: "",
        IsCompany: false,
        IdNo: "",
        TaxNo: "",
        BirthDate: null,
        Gender: 0,
        TelNo: "",
        CellTelNo: "",
        WorkTelNo: "",
        FaxNo: "",
        AddressType: 1,
        Address1: "",
        Address2: "",
        Address3: "",
        Address4: "",
        Address5: "",
        CareOf: "",
        FlatName: "",
        FlatNo: "",
        HouseNo: "",
        Code: "",
        PersonalAddressType: 1,
        PersonalAddress1: "",
        PersonalAddress2: "",
        PersonalAddress3: "",
        PersonalAddress4: "",
        PersonalAddress5: "",
        PersonalCareOf: "",
        PersonalFlatName: "",
        PersonalFlatNo: "",
        PersonalHouseNo: "",
        PersonalCode: "",
        NoSms: false,
        ConsentReceiveEmail: false,
        ConsentReceiveSms: false,
        Files: [],
      },
      currentTab: "general",
      deleteItem: null,
      deleteItemIdx: null,
      showConfirmDelete: false,
      iUploadByteSize: 4000000,
      fileExtensionsAllowed: [".pdf", ".jpg", ".jpeg", ".png"],
      fileExtensionsAllowedDisplay: "*.pdf, *.jpg, *.jpeg, *.png",
      personalAddressSameAsMail: true,
      customFields: [],
      registrationSuccessfull: false,
      otpSuccessfull: false,
    };
  },
  validations: {
    dataObj: {
      AccountType: {
        required,
      },
      ConsumerType: {
        required,
      },
      Initial: {
        required: requiredIf(function () {
          return this.showNameInput;
        }),
      },
      Surname: {
        required,
      },
      Email: {
        email,
        required,
      },
      CellTelNo: {
        required: requiredIf(function () {
          return this.dataObj.CellTelNo;
        }),
        regExpression,
      },
    },
  },
  computed: {
    showNameInput: function () {
      return this.dataObj.AccountType == "0";
    },
    showNextButt: function () {
      if (this.showCustomFields) {
        return this.currentTab != "customFields";
      } else return this.currentTab != "attachments";
    },
    fileTypesMessage: function () {
      return (
        this.$t("formCusteval.FileTypesSupported") +
        this.fileExtensionsAllowedDisplay
      );
    },
    adressLinesNames: function () {
      return [
        this.lookups.uncodedAddressLineNames &&
        this.lookups.uncodedAddressLineNames[0]
          ? this.lookups.uncodedAddressLineNames[0]
          : this.$t("drilling.AddressLine1"),
        this.lookups.uncodedAddressLineNames &&
        this.lookups.uncodedAddressLineNames[1]
          ? this.lookups.uncodedAddressLineNames[1]
          : this.$t("drilling.AddressLine2"),
        this.lookups.uncodedAddressLineNames &&
        this.lookups.uncodedAddressLineNames[2]
          ? this.lookups.uncodedAddressLineNames[2]
          : this.$t("drilling.AddressLine3"),
        this.lookups.uncodedAddressLineNames &&
        this.lookups.uncodedAddressLineNames[3]
          ? this.lookups.uncodedAddressLineNames[3]
          : this.$t("drilling.AddressLine4"),
        this.lookups.uncodedAddressLineNames &&
        this.lookups.uncodedAddressLineNames[4]
          ? this.lookups.uncodedAddressLineNames[4]
          : this.$t("drilling.AddressLine5"),
      ];
    },
  },
  watch: {
    birthDate: function (val) {
      if (val) this.dataObj.BirthDate = moment(val).format();
    },
    timerCount: {
      handler(value) {
        if (value > 0) {
          setTimeout(() => this.timerCount--, 1000);
          this.timerCountDisplay =
            this.secsToMins(this.timerCount) +
            this.$t("EbillRegistration.sessionExpiry");
        } else if (this.timerStarted == true) {
          this.timerCountDisplay = this.$t("EbillRegistration.sessionExpired");
          this.regExpired = true;
          this.showMessage(this.$t("EbillRegistration.sessionExpired"), 2);
          this.expiryTmeout = setTimeout(() => {
            this.$router.push("/login");
          }, 2000);
        } else this.timerCountDisplay = "";
      },
      immediate: true, // This ensures the watcher is triggered upon creation
    },
  },
  created() {
    let sett = this.$store.getters.getSettings;
    if (sett != null && sett != undefined)
      this.timeLimit = sett.otpSessionStepSeconds;

    this.$material.locale.dateFormat = "dd/MM/yyyy";
    this.getLookups();
    this.getCustomFields();
    this.getMessage();

    this.$store
      .dispatch("getUtilitySettings")
      .then((resp) => {
        this.phonePrefix = resp.customerMobileNoPrefix;
        this.regExpr = resp.customerMobileNoRegExpr;
        this.lookups.uncodedAddressLineNames =
          resp.customerUncodedAddressLineNames;
      })
      .catch(
        () => (this.lookups.uncodedAddressLineNames = ["", "", "", "", ""])
      );

    // this.dataObj = {
    //   PortalApplicationId: -1,
    //   AccountType: 0,
    //   ConsumerType: "01/00",
    //   Initial: "sac",
    //   Surname: "csa",
    //   Email: "fdfd@kjdjd.cc",
    //   Title: "sac",
    //   IsCompany: false,
    //   IdNo: "csa",
    //   TaxNo: "csa",
    //   BirthDate: null,
    //   Gender: 2,
    //   TelNo: "99663322",
    //   CellTelNo: "99663322",
    //   WorkTelNo: "75465",
    //   FaxNo: "",
    //   AddressType: 1,
    //   Address1: "cc",
    //   Address2: "ss",
    //   Address3: "qq1`11",
    //   Address4: "ss",
    //   Address5: "ss",
    //   CareOf: "",
    //   FlatName: "",
    //   FlatNo: "",
    //   HouseNo: "",
    //   Code: "",
    //   PersonalAddressType: 1,
    //   PersonalAddress1: "cc",
    //   PersonalAddress2: "ss",
    //   PersonalAddress3: "qq1`11",
    //   PersonalAddress4: "ss",
    //   PersonalAddress5: "ss",
    //   PersonalCareOf: "",
    //   PersonalFlatName: "",
    //   PersonalFlatNo: "",
    //   PersonalHouseNo: "",
    //   PersonalCode: "",
    //   NoSms: false,
    //   ConsentReceiveEmail: true,
    //   ConsentReceiveSms: true,
    //   Files: [],
    // };
  },
  methods: {
    createSession(register = false) {
      this.isRegistering = true;
      axios
        .post("/Session/Create", {
          MobileNo: this.appendPrefixOnTelephone(this.dataObj.CellTelNo),
          Email: this.dataObj.Email,
          LanguageCode: this.getLanguage(),
        })
        .then((response) => {
          if (response.status == 200) {
            if (register) {
              this.registrationSuccessfull = true;
            }

            this.sessionId = response.data;

            this.showMessage(this.$t("EbillRegistration.OtpCodesSend"), 3);
            this.timerCount = this.timeLimit;
            this.timerStarted = true;
            this.otpSent();
          } else
            this.showMessage(this.$t("EbillRegistration.ErrorGettingOTP"), 1);
        })
        .catch((e) => {
          this.showMessage(
            this.$t("EbillRegistration.ErrorGettingOTP") +
              ": " +
              e.response.data,
            1
          );
        })
        .finally(() => {
          this.isRegistering = false;
        });
    },
    getMessage() {
      axios
        .post("/Utility/GetMessage", { Lang: this.$i18n.locale, TextId: 114 })
        .then((response) => {
          if (response.data.data.status == 0)
            this.registrationMessage =
              response.data.settings.text ??
              this.$t("messages.registrationHasBeenCompleted");
        });
    },
    getCustomFields() {
      axios
        .get(
          "/NewCustomer/GetCustomFields?language=" +
            this.$localStorage.get("_lang")
        )
        .then((response) => {
          if (response.data.data.status === 0) {
            response.data.items.forEach((field) => {
              if (field.dateValue == "1899-12-30T00:00:00")
                field.dateValue = moment().format();
            });
            this.customFields = response.data.items;

            if (this.customFields && this.customFields.length > 0)
              this.showCustomFields = true;
            else this.showCustomFields = false;
          } else
            this.$notify({
              duration: 10000,
              group: "app",
              text:
                response.data.data.text +
                this.$t("messages.CannotGetDataFromServer"),
              type: "warn",
            });
        })
        .catch((e) => {
          //this.$router.push('/login');
        });
    },

    addressPrefChange(value) {
      if (value) return;

      this.dataObj.Code = "";
      this.dataObj.CareOf = "";
      this.dataObj.HouseNo = "";
      this.dataObj.FlatNo = "";
      this.dataObj.FlatName = "";

      this.dataObj.Address1 = "";
      this.dataObj.Address2 = "";
      this.dataObj.Address3 = "";
      this.dataObj.Address4 = "";
      this.dataObj.Address5 = "";
    },
    validation() {
      this.$v.dataObj.$touch();

      if (this.$v.dataObj.$invalid) {
        this.tabs[this.currentTab].error = " ";
        this.$notify({
          duration: 10000,
          group: "app",
          text: this.$t("drilling.ErrRequiredFields"),
          type: "warn",
        });
        return false;
      }

      this.tabs[this.currentTab].error = null;
      this.tabs[this.currentTab].sync = true;
      return true;
    },
    customFieldsValidation() {
      return this.customFields.every((customField) => {
        if (!customField.isMandatory) return true;
        else {
          if (customField.type == 0) return customField.strValue;
          else if (customField.type == 1) return customField.intValue;
          else if (customField.type == 2) return customField.dblValue;
          else if (customField.type == 3) return customField.dateValue;
          else if (customField.type == 4) return customField.dataId;
          else if (customField.type == 5) return customField.typeId;
        }
      });
    },
    navigation(whereTo) {
      if (whereTo == "login") {
        this.$router.push(`/${whereTo}`);
        return;
      }

      if (this.currentTab == "attachments") {
        //no validation tab
        this.tabs.attachments.error = null;
        this.tabs.attachments.sync = true;
      } else {
        if (!this.validation()) return;
      }

      if (whereTo == "next") {
        if (this.currentTab == "general") this.currentTab = "consent";
        else if (this.currentTab == "consent") this.currentTab = "addresses";
        else if (this.currentTab == "addresses") {
          if (this.personalAddressSameAsMail) {
            this.dataObj.Code = this.dataObj.PersonalCode;
            this.dataObj.CareOf = this.dataObj.PersonalCareOf;
            this.dataObj.HouseNo = this.dataObj.PersonalHouseNo;
            this.dataObj.FlatNo = this.dataObj.PersonalFlatNo;
            this.dataObj.FlatName = this.dataObj.PersonalFlatName;

            this.dataObj.Address1 = this.dataObj.PersonalAddress1;
            this.dataObj.Address2 = this.dataObj.PersonalAddress2;
            this.dataObj.Address3 = this.dataObj.PersonalAddress3;
            this.dataObj.Address4 = this.dataObj.PersonalAddress4;
            this.dataObj.Address5 = this.dataObj.PersonalAddress5;
          }

          this.currentTab = "attachments";
        } else if (this.currentTab == "attachments")
          this.currentTab = "customFields";
      } else if (whereTo == "back") {
        if (this.currentTab == "consent") this.currentTab = "general";
        else if (this.currentTab == "addresses") this.currentTab = "consent";
        else if (this.currentTab == "attachments")
          this.currentTab = "addresses";
        else if (this.currentTab == "customFields")
          this.currentTab = "attachments";
      }
    },
    getLookups() {
      axios
        .post("/NewCustomer/GetLookups")
        .then(async (response) => {
          //console.log(response);
          if (response.status == 200) {
            this.lookups = response.data;
            //if (this.lookups.consumerTypes.length > 0)
            //  this.dataObj.ConsumerType = this.lookups.consumerTypes[0].value;

            if (this.lookups.genders.length > 0)
              this.dataObj.Gender = this.lookups.genders[0].value;

            this.lookups.accountTypes = [
              { selected: false, text: this.$t("formCusteval.Indi"), value: 0 },
              { selected: false, text: this.$t("formCusteval.Corp"), value: 1 },
            ];
          } else {
            this.$notify({
              duration: 10000,
              group: "app",
              text: response.data,
              type: "warn",
            });
          }
        })
        .catch((error) => {
          console.log(error.response);
          this.$notify({
            duration: 10000,
            group: "app",
            text: error.response.data,
            type: "warn",
          });
        });
    },
    changeTab(e) {
      this.currentTab = e;
    },
    appendPrefixOnTelephone(phone) {
      return `${this.phonePrefix}${phone}`;
    },
    createApplication() {
      if (
        !this.validation() ||
        !this.customFieldsValidation() ||
        !this.emailOtpCode ||
        !this.phoneOtpCode
      ) {
        this.$notify({
          duration: 10000,
          group: "app",
          text: this.$t("drilling.ErrRequiredFields"),
          type: "warn",
        });
        return;
      }

      this.isRegistering = true;
      if (this.dataObj.AccountType == 1) this.dataObj.IsCompany = true;
      else this.dataObj.IsCompany = false;

      delete this.dataObj.AccountType;

      let formData = new FormData();

      formData.append("SessionId", this.sessionId);
      formData.append("SmsOtpCode", this.phoneOtpCode);
      formData.append("EmailOtpCode", this.emailOtpCode);
      formData.append("LanguageCode", this.getLanguage());

      for (const obj in this.dataObj) {
        if (obj != "Files")
          formData.append(
            obj,
            obj == "TelNo" ||
              obj == "CellTelNo" ||
              obj == "WorkTelNo" ||
              obj == "FaxNo"
              ? this.appendPrefixOnTelephone(this.dataObj[obj])
              : this.dataObj[obj]
          );
      }

      for (var i = 0; i < this.dataObj.Files.length; ++i)
        formData.append("Files", this.dataObj.Files[i].file);

      axios
        .post("/NewCustomer/CreateApplication", formData, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then((response) => {
          if (response.status == 200) {
            clearTimeout(this.expiryTmeout);
            if (this.showCustomFields) {
              this.saveCustomFields(response.data).then((resp) => {
                if (!resp.status) {
                  this.$notify({
                    duration: 10000,
                    group: "app",
                    text: resp.err,
                    type: "error",
                  });
                  this.$router.push("/login");
                }
              });
            }

            this.getRegistrationMsg();

            this.otpSuccessfull = true;
          } else {
            this.$notify({
              duration: 10000,
              group: "app",
              text: response.data,
              type: "error",
            });
            this.$router.push("/login");
          }
        })
        .catch((error) => {
          console.log(error.response);
          if (
            error.response &&
            error.response.data &&
            error.response.data.message
          )
            this.$notify({
              duration: 10000,
              group: "app",
              text: error.response.data.message,
              type: "error",
            });
          else {
            this.$notify({
              duration: 10000,
              group: "app",
              text: error,
              type: "error",
            });
            //this.$router.push("/login");
          }
        })
        .finally(() => {
          this.isRegistering = false;
        });
    },
    getRegistrationMsg() {
      axios
        .post("/Utility/GetMessage", { Lang: this.$i18n.locale, TextId: 115 })
        .then((response) => {
          if (response.data.data.status == 0)
            this.registrationMsg = response.data.settings.text;
        });
    },
    saveCustomFields(appId) {
      let fields = [...this.customFields];

      fields.forEach((f) => {
        if (f.type == 4 && typeof f.dataId == "object") {
          f.dataId = f.dataId.itemId;
        }
      });
      var parameter = {
        ApplicationId: appId,
        Values: fields,
        language: this.$localStorage.get("_lang"),
      };

      return axios
        .post("/NewCustomer/SaveCustomFieldValues", parameter)
        .then((response) => {
          if (response.data.data.status === 0) return { status: true };
          else return { status: false, err: response.data.data.text };
        })
        .catch((err) => {
          return { status: false, err };
        });
    },
    getValidationClass(obj1, obj2) {
      const field = this.$v[obj1][obj2];

      if (field) {
        if (obj2 == "CellTelNo")
          return {
            "md-invalid":
              (field.$invalid || !field.regExpression) && field.$dirty,
          };
        else
          return {
            "md-invalid": field.$invalid && field.$dirty,
          };
      }
    },
    onFileSelected(event) {
      //console.log("onFileSelected", event);
      let fileList = event.value;

      if (fileList.length != 0)
        fileList.forEach((f) =>
          this.dataObj.Files.push({
            name: f.name,
            file: f,
            id: this.dataObj.Files.length + 1,
            size: this.formatBytes(f.size),
          })
        );
    },
    showDeleteConfirmDialog(item, idx) {
      this.deleteItem = item;
      this.deleteItemIdx = idx;
      this.showConfirmDelete = true;
    },
    deleteItemFun() {
      //console.log(this.deleteItemIdx);
      //console.log(this.deleteItem);
      //console.log(this.dataObj.Files);

      this.dataObj.Files.splice(this.deleteItemIdx, 1);
    },

    formatBytes(bytes, decimals = 2) {
      if (!+bytes) return "0 Bytes";

      const k = 1024;
      const dm = decimals < 0 ? 0 : decimals;
      const sizes = [
        "Bytes",
        "KiB",
        "MiB",
        "GiB",
        "TiB",
        "PiB",
        "EiB",
        "ZiB",
        "YiB",
      ];

      const i = Math.floor(Math.log(bytes) / Math.log(k));

      return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
    },
    getLanguage() {
      let lang = this.$localStorage.get("_lang");
      return lang != null && lang != "" ? lang : "el";
    },
    showMessage(msg, type) {
      //if (type === 2)
      //  msg += ' ' + this.$t('messages.ProblemPersistsContactSupport');
      this.$notify({
        duration: 10000,
        group: "app",
        text: msg,
        type:
          type == 1 ? "warn" : type == 2 ? "error" : type == 3 ? "success" : "",
      });
    },

    secsToMins(time) {
      var minutes = Math.floor(time / 60);
      var seconds = time - minutes * 60;
      return minutes + "m " + seconds + "s ";
    },
  },
};
